export default __webpack_public_path__ + "static/media/Group 33460.791cbc73.png";